<script>
    import CRUD from './CRUD.svelte';
    import { 
        fetchTipos, 
        saveTipo, 
        removeTipo, 
        searchTipos, 
        subscribeToTipos, 
        unsubscribeFromTipos 
    } from '../controllers/tipoController.js';
    import { onMount } from 'svelte';
    import { t } from 'svelte-i18n';

    let tipoColumns = [
        { label: $t('fields.description'), field: 'descrip', type: 'text' },
        { label: $t('fields.state'), field: 'sta', type: 'bool' },
    ];

    let newTipo = {
        descrip: '',
        sta: true,
    };

    let editColumns = [
        { label: $t('fields.description'), key: 'descrip', type: 'text', required: true },
        { label: $t('fields.state'), key: 'sta', type: 'checkbox' },
    ];

    onMount(() => {
        console.log("Componente de Tipos montado");
    });
</script>

<CRUD 
    title={$t('entities.tipos')}
    entityName="tipo"
    newEntity={newTipo}
    columns={tipoColumns}
    fetchEntities={fetchTipos}
    saveEntity={saveTipo}
    removeEntity={removeTipo}
    searchEntities={searchTipos}
    subscribeToChanges={subscribeToTipos}
    unsubscribeFromChanges={unsubscribeFromTipos}
    editColumns={editColumns}
/>
